var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { fabric } from 'fabric';
import { cloneDeep } from 'lodash';
import { Wrapper, LoadingLine } from '@mademine/components';
import { useI18n } from '@mademine/hooks';
import { I18n, Gtag } from '@mademine/utils';
import { Oss } from '@sunzi/utils';
import { Provide } from '../hooks/useData';
import en_US from '../lang/en_US.json';
import de_DE from '../lang/de_DE.json';
import fr_FR from '../lang/fr_FR.json';
import it_IT from '../lang/it_IT.json';
import es_ES from '../lang/es_ES.json';
import ja_JP from '../lang/ja_JP.json';
import pt_BR from '../lang/pt_BR.json';
import Choose from './Choose';
import Zuploader from './Zuploader';
import Cropper from './Cropper';
import Facut from './Facut';
import RecognitionLoading from './RecognitionLoading';
import Preview from './Preview';
import Clip from './Clip';
import DoubleSizeIncrementDrawer from '../components/incementDrawer/DoubleSize';
import RelativeProduct from '../components/RelativeProduct';
import RecordIncement from '../components/incementDrawer/Recorder';
import Drawer from '../components/Drawer';
import TextInputEdit from '../components/TextInputEdit';
import { compressImage, getFaceData, getToken7n, loadBase64FromURL, loadHTMLImage, loadImageFromURL, saveLocalImage, uploadKey, replaceUrlAsOss, upload2Oss } from '../utils';
import { DEFAULT_IMAGE, SaveLocalKey } from '../config';
import Edit from './Edit';
import { IncrementType, TaskStatus } from './index';
import DoubleSideEditDrawer from '../components/DoubleSideEditDrawer';
import VisualizePreview from '../components/VisualizePreview';
Gtag.setCategory('sunzi-mini-me-double-people');
var oss = new Oss();
oss.bucket('sunzi-cn');
var Custom = function (_a) {
    var _b, _c;
    var shop = _a.shop, _d = _a.productType, productType = _d === void 0 ? 'mini-me' : _d, _e = _a.peopleNumber, peopleNumber = _e === void 0 ? 1 : _e, colors = _a.colors, miniMeData = _a.miniMeData, defaultOption = _a.defaultOption, stickerData = _a.stickerData, defalutMiniMeData = _a.defalutMiniMeData, defaultImage = _a.defaultImage, defaultTemplateId = _a.defaultTemplateId, sideCount = _a.sideCount, colorVariants = _a.colorVariants, templateIdDoSkipAr = _a.templateIdDoSkipAr, templateIdElectricCard = _a.templateIdElectricCard, electricCard = _a.electricCard, relatedRecordProduct = _a.relatedRecordProduct, templateIdChristmasBag = _a.templateIdChristmasBag, christmasBag = _a.christmasBag, productIncrement = _a.productIncrement, newTemplateArDatas = _a.newTemplateArDatas, sizeData = _a.sizeData, shareLink = _a.shareLink, selectedColor = _a.selectedColor, selectedSize = _a.selectedSize, relativeProducts = _a.relativeProducts, guideImage = _a.guideImage, textInputSettings = _a.textInputSettings, _f = _a.doubleSize, doubleSize = _f === void 0 ? true : _f, setCurrentSize = _a.setCurrentSize, setSelectedColor = _a.setSelectedColor, onClose = _a.onClose, onConfirm = _a.onConfirm;
    useI18n(shop.language, { en_US: en_US, de_DE: de_DE, fr_FR: fr_FR, it_IT: it_IT, es_ES: es_ES, ja_JP: ja_JP, pt_BR: pt_BR });
    var partialInputSetting = textInputSettings === null || textInputSettings === void 0 ? void 0 : textInputSettings.map(function (inputSetting) {
        var _a;
        return ({
            title: (_a = inputSetting === null || inputSetting === void 0 ? void 0 : inputSetting.title) === null || _a === void 0 ? void 0 : _a.en_US,
            value: inputSetting.value,
            font: inputSetting.font
        });
    });
    var _g = useState(TaskStatus.Recognition), taskStatus = _g[0], setTaskStatus = _g[1];
    var _h = useState({}), sortOption = _h[0], setSortOption = _h[1];
    var _j = useState(new Array(peopleNumber).fill(undefined).map(function () {
        return [cloneDeep(DEFAULT_IMAGE)];
    })), images = _j[0], setImages = _j[1];
    var _k = useState(false), zuploaderVisible = _k[0], setZuploaderVisible = _k[1];
    var _l = useState(false), cutState = _l[0], setCutState = _l[1];
    var _m = useState(['']), cutSource = _m[0], setCutSource = _m[1];
    var _o = useState(false), facutVisible = _o[0], setFacutVisible = _o[1];
    var _p = useState(['']), facutSource = _p[0], setFacutSource = _p[1];
    var _q = useState(0), peopleIndex = _q[0], setPeopleIndex = _q[1];
    var _r = useState('playing'), loadingState = _r[0], setLoadingState = _r[1];
    var _s = useState(''), loadingImage = _s[0], setLoadingImage = _s[1];
    var _t = useState(), selectedOption = _t[0], setSelectedOption = _t[1];
    var _u = useState(false), incrementDrawerVisible = _u[0], setIncrementDrawerVisible = _u[1];
    var _v = useState(false), imageDrawerVisible = _v[0], setImageDrawerVisible = _v[1];
    var _w = useState(false), editVisible = _w[0], setEditVisible = _w[1];
    var _x = useState(christmasBag), christmasBagData = _x[0], setChristmasBagData = _x[1];
    var _y = useState(0), addedPrice = _y[0], setAddedPrice = _y[1];
    var _z = useState(false), clipVisible = _z[0], setClipVisible = _z[1];
    var _0 = useState(false), relativeProductVisible = _0[0], setRelativeProductVisible = _0[1];
    var _1 = useState(false), passPrviewEdit = _1[0], setPassPreviewEdit = _1[1];
    var _2 = useState(false), recordIncementVisible = _2[0], setRecordIncementVisible = _2[1];
    var _3 = useState(false), addCartLoading = _3[0], setAddCartLoading = _3[1];
    var _4 = useState(false), isShare = _4[0], setIsShare = _4[1];
    var _5 = useState(false), recognitionLoadingVisible = _5[0], setRecognitionLoadingVisible = _5[1];
    var _6 = useState(false), drawVisible = _6[0], setDrawVisible = _6[1];
    var _7 = useState(partialInputSetting), inputTextDataText = _7[0], setInputTextDataText = _7[1];
    var _8 = useState(1), currentSide = _8[0], setCurrentSide = _8[1];
    var _choose = useRef(null);
    var _first = useRef(true);
    var canvasData = useRef([]);
    var colorVariantsValue = useRef([]);
    var factoryData = useRef();
    var _templateIdData = useRef();
    var incrementType = useRef();
    var relatedRecordProductStatus = useRef({ addRecord: false });
    var _relativeProducts = useRef([]);
    var _clip = useRef(null);
    var stickerCompose = useRef();
    var _9 = useState([]), selectedRelatedProduct = _9[0], setSelectedRelatedProduct = _9[1];
    var _10 = useState(), backSideNewImage = _10[0], setBackSideNewImage = _10[1];
    var _11 = useState(false), hasBackSideUpload = _11[0], setHasBackSideUpload = _11[1];
    var _12 = useState(false), viualizerPreviewVisible = _12[0], setViualizerPreviewVisible = _12[1];
    var EditPageNextElement = useRef(null);
    var _13 = useState(''), imageDataFor3dPreview = _13[0], setImageDataFor3dPreview = _13[1];
    var loadShareImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2];
        });
    }); };
    var processingData = function () {
        if (!defalutMiniMeData)
            return;
        var sortedColors = [];
        colors.forEach(function (item) {
            if (item.belongPeople !== undefined) {
                if (!sortedColors[item.belongPeople]) {
                    sortedColors[item.belongPeople] = [item];
                }
                else
                    sortedColors[item.belongPeople].push(item);
            }
            else {
                if (!sortedColors[0])
                    sortedColors[0] = [item];
                else
                    sortedColors[0].push(item);
            }
        });
        var colorsName = [];
        var length = 0;
        var addColor = function (colorList) {
            if (length === 0) {
                colorList.forEach(function (item) {
                    colorsName.push(item.name);
                });
            }
            else {
                var tempColorsName_1 = [];
                colorList.forEach(function (item) {
                    var newColorsName = __spreadArray([], colorsName, true);
                    newColorsName = newColorsName.map(function (newColorsNameitem) {
                        newColorsNameitem += "-".concat(item.name);
                        return newColorsNameitem;
                    });
                    tempColorsName_1.push.apply(tempColorsName_1, newColorsName);
                });
                colorsName = tempColorsName_1;
            }
            length += 1;
            if (length < sortedColors.length)
                addColor(sortedColors[length]);
        };
        addColor(sortedColors[length]);
        var face = defalutMiniMeData.face, width = defalutMiniMeData.width, height = defalutMiniMeData.height;
        miniMeData.forEach(function (item) {
            item.images.forEach(function (image) {
                if (!image.face)
                    image.face = cloneDeep(face);
                else if (!Array.isArray(image.face))
                    image.face = [image.face];
                if (!image.avatar) {
                    var imageAvatar = image.face.map(function (item) {
                        return __assign(__assign({}, item), { width: item.width + 100, height: item.height + 100, left: item.left - 50, top: item.top - 100 });
                    });
                    image.avatar = imageAvatar;
                }
                else if (!Array.isArray(image.avatar))
                    image.avatar = [image.avatar];
                if (!image.width)
                    image.width = width;
                if (!image.height)
                    image.height = height;
                if (typeof image.images === 'string') {
                    image.images = [
                        {
                            color: colorsName,
                            url: image.images
                        }
                    ];
                }
                if (image.annex) {
                    image.annex.forEach(function (annexItem) {
                        if (typeof annexItem.images === 'string') {
                            annexItem.images = [
                                {
                                    color: colorsName,
                                    url: replaceUrlAsOss(annexItem.images)
                                }
                            ];
                        }
                    });
                }
                if (image.face) {
                    image.face.forEach(function (faceItem) {
                        if (faceItem.path) {
                            faceItem.path = replaceUrlAsOss(faceItem.path);
                        }
                    });
                }
                if (image.avatar) {
                    image.avatar.forEach(function (avatarItem) {
                        if (avatarItem.path) {
                            avatarItem.path = replaceUrlAsOss(avatarItem.path);
                        }
                    });
                }
                if (image.text) {
                    image.text.forEach(function (textItem) {
                        if (textItem.font && textItem.font.url)
                            textItem.font.url = replaceUrlAsOss(textItem.font.url);
                    });
                }
            });
        });
    };
    var requestCutFace = function (image) { return __awaiter(void 0, void 0, void 0, function () {
        var userImage, compressImg, img, _a, faceRecognizeData, htmlImage, height, width, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userImage = {
                        source: cutSource[peopleIndex],
                        image: image,
                        height: 0,
                        width: 0,
                        userImage: cutSource[peopleIndex]
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4, compressImage(cutSource[peopleIndex], 800)];
                case 2:
                    compressImg = _b.sent();
                    return [4, loadBase64FromURL(image, 800, 'png')];
                case 3:
                    img = _b.sent();
                    return [4, Promise.all([
                            getFaceData(img),
                            loadHTMLImage(img)
                        ])];
                case 4:
                    _a = _b.sent(), faceRecognizeData = _a[0], htmlImage = _a[1];
                    height = htmlImage.height, width = htmlImage.width;
                    userImage = {
                        source: compressImg,
                        image: img,
                        height: height,
                        width: width,
                        userImage: cutSource[peopleIndex],
                        faceRecognizeData: faceRecognizeData
                    };
                    saveLocalImage(userImage);
                    setLoadingState('success');
                    return [3, 7];
                case 5:
                    err_1 = _b.sent();
                    setLoadingState('fail');
                    return [3, 7];
                case 6:
                    images[peopleIndex][currentSide - 1] = userImage;
                    setImages(cloneDeep(images));
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    var createImageList = function () {
        var all = {};
        var allName = I18n.format('modules.mini.me.all') || '';
        sortOption[allName] = [];
        miniMeData.forEach(function (item) {
            var key = "".concat(item.name, "-").concat(item.id);
            sortOption[key] = [];
            item.images.forEach(function (image) {
                var _a;
                var imageData = {
                    id: image.id,
                    origin: image,
                    loading: {
                        body: true
                    }
                };
                if (!Object.prototype.hasOwnProperty.call(all, image.id)) {
                    all[image.id] = imageData;
                    (_a = image.annex) === null || _a === void 0 ? void 0 : _a.map(function (annex) { return (imageData.loading["annex-".concat(annex.id)] = true); });
                    if (image.id == defaultOption) {
                        sortOption[key].unshift(imageData);
                        sortOption[allName].unshift(imageData);
                    }
                    else {
                        sortOption[key].push(imageData);
                        sortOption[allName].push(imageData);
                    }
                }
                else {
                    sortOption[key].push(all[image.id]);
                }
            });
        });
    };
    var directToPreview = function () {
        if (!defaultTemplateId)
            return false;
        var selectedName = I18n.format('modules.mini.me.all') || '';
        var option = sortOption[selectedName].find(function (option) { return option.id == defaultTemplateId; });
        if (!option)
            return false;
        setSelectedOption(option);
        setTaskStatus(TaskStatus.Preview);
        return true;
    };
    var handleClose = function (force) {
        if (defaultImage && !force) {
            setCutState(false);
            _first.current = true;
            canvasData.current = [];
            setZuploaderVisible(true);
        }
        else {
            setStateInit();
            onClose();
        }
    };
    var setStateInit = function () {
        var _a;
        setCutState(false);
        setRecordIncementVisible(false);
        setRelativeProductVisible(false);
        if (peopleNumber > 1) {
            setTaskStatus(TaskStatus.Choose);
            setRecognitionLoadingVisible(false);
            setZuploaderVisible(false);
        }
        else {
            setTaskStatus(TaskStatus.Recognition);
            setRecognitionLoadingVisible(true);
            setZuploaderVisible(true);
        }
        canvasData.current = [];
        setCurrentSide(1);
        setSelectedOption(undefined);
        if ((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.origin) === null || _a === void 0 ? void 0 : _a.text) {
            selectedOption.origin.text.forEach(function (item) {
                item.text = '';
            });
        }
        setIsShare(false);
        setEditVisible(false);
        setClipVisible(false);
        setIncrementDrawerVisible(false);
        setAddedPrice(0);
        setImages(new Array(peopleNumber).fill(undefined).map(function () {
            return [cloneDeep(DEFAULT_IMAGE)];
        }));
        relatedRecordProductStatus.current = {
            addRecord: false
        };
        _first.current = true;
        incrementType.current = undefined;
    };
    var setFactoryData = function (data) { return (factoryData.current = data); };
    var setIncrementType = function (type) {
        return (incrementType.current = type);
    };
    var handleZuploaderClose = function () {
        setZuploaderVisible(false);
        if (_first.current && peopleNumber === 1) {
            handleClose(true);
        }
        else {
            setIncrementType(0);
            setAddedPrice(0);
            setZuploaderVisible(false);
            setCurrentSide(1);
        }
    };
    var handleZuploaderConfirm = function (output) {
        if (_first.current) {
            _first.current = false;
        }
        setCutState(true);
        setEditVisible(false);
        setIncrementDrawerVisible(false);
        var image = output[0].objectURL;
        cutSource[peopleIndex] = image;
        setCutSource(__spreadArray([], cutSource, true));
    };
    var handleSelectedLocalImage = function (userImage) {
        if (_first.current) {
            _first.current = false;
        }
        images[peopleIndex][currentSide - 1] = userImage;
        setImages(cloneDeep(images));
        setPeopleIndex(peopleIndex + 1);
        setZuploaderVisible(false);
        setEditVisible(false);
        if (directToPreview()) {
        }
        if (_choose.current) {
            setTimeout(function () { var _a; return (_a = _choose.current) === null || _a === void 0 ? void 0 : _a.update(); }, 0);
        }
    };
    var handleBlurTipReplace = function () {
        setZuploaderVisible(true);
        Gtag.event('event_blur_replace');
    };
    var handleTemplateArDataFilter = function (id) {
        var filteredData;
        if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.origin.arImages) {
            var arImages = selectedOption.origin.arImages;
            var hadArImage = arImages === null || arImages === void 0 ? void 0 : arImages.find(function (item) {
                return item.color.includes(selectedColor.map(function (item) { return item.name; }).join('-'));
            });
            if (hadArImage)
                return false;
        }
        if (newTemplateArDatas) {
            newTemplateArDatas.forEach(function (item) {
                if (item.id == id) {
                    filteredData = item;
                }
            });
        }
        return filteredData ? filteredData : false;
    };
    var handleIncrement = function () {
        switch (incrementType.current) {
            case IncrementType.SameSide: {
                Gtag.event('event_one_side_print');
                setIncrementDrawerVisible(false);
                handleIncrementDrawer();
                break;
            }
            case IncrementType.DoubleSide: {
                Gtag.event('event_double_side_print');
                setIncrementDrawerVisible(false);
                handleIncrementDrawer();
                break;
            }
            case IncrementType.NewImageSide: {
                Gtag.event('event_two_image_print');
                setIncrementDrawerVisible(false);
                if (hasBackSideUpload || currentSide === 2) {
                    handleIncrementDrawer();
                }
                break;
            }
        }
    };
    var _handleResetAddData = function () {
        var _a, _b;
        setChristmasBagData(christmasBag);
        var arFilterResult = handleTemplateArDataFilter((_a = canvasData.current[0].image) === null || _a === void 0 ? void 0 : _a.id);
        if (((_b = canvasData.current[0].image) === null || _b === void 0 ? void 0 : _b.id) != arFilterResult.id &&
            templateIdDoSkipAr)
            return;
        if (templateIdElectricCard) {
            electricCard = templateIdElectricCard;
        }
        else {
            electricCard = _templateIdData.current.cardData.origin;
        }
        if (arFilterResult && templateIdDoSkipAr) {
            relatedRecordProduct = arFilterResult.ar;
        }
        else {
            relatedRecordProduct = _templateIdData.current.recordData.origin;
        }
        if (templateIdChristmasBag) {
            christmasBag = templateIdChristmasBag;
            setChristmasBagData(templateIdChristmasBag);
        }
        else {
            christmasBag = _templateIdData.current.christmasBagData.origin;
        }
    };
    var handleIncrementDrawer = function (pass) {
        _handleResetAddData();
        if (textInputSettings && !(pass === null || pass === void 0 ? void 0 : pass.userText)) {
            setDrawVisible(true);
        }
        else if (relativeProducts && relativeProducts.length > 0) {
            setRelativeProductVisible(true);
        }
        else if (relatedRecordProduct) {
            setRecordIncementVisible(true);
        }
        else if (shareLink) {
        }
        else {
            handleAddCart(factoryData.current);
        }
    };
    useEffect(function () {
        fabric.Object.prototype.objectCaching = false;
        processingData();
        createImageList();
        var stringData = JSON.parse(window.localStorage.getItem(SaveLocalKey)) || [];
        var userImages = stringData.map(function (item) { return item.userImage; });
        var isLocalImageInDefalutImage = defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.some(function (item) {
            return userImages.includes(item);
        });
        if (defaultImage && !isLocalImageInDefalutImage) {
            if (defaultImage.length > 0) {
                console.error('默认头目前只有适配一个头的逻辑，请检查您的数据');
                return;
            }
            setRecognitionLoadingVisible(true);
            setZuploaderVisible(false);
            setFacutSource(defaultImage);
            setFacutVisible(true);
        }
        _templateIdData.current = {
            recordData: {
                origin: relatedRecordProduct,
                current: newTemplateArDatas && newTemplateArDatas[0].ar
            },
            cardData: {
                origin: electricCard,
                current: templateIdElectricCard
            },
            christmasBagData: {
                origin: christmasBag,
                current: templateIdChristmasBag
            }
        };
    }, []);
    var handleCropperClose = function () {
        setCutState(false);
        cutSource[peopleIndex] = '';
        setCutSource(__spreadArray([], cutSource, true));
        setZuploaderVisible(true);
        setRecognitionLoadingVisible(false);
    };
    var handleCropperConfirm = function (source) {
        facutSource[peopleIndex] = source;
        setFacutSource(__spreadArray([], facutSource, true));
        setFacutVisible(true);
        setRecognitionLoadingVisible(true);
    };
    var handleFacutClose = function () {
        setCutState(false);
        setFacutVisible(false);
        facutSource[peopleIndex] = '';
        setFacutSource(__spreadArray([], facutSource, true));
        setZuploaderVisible(true);
        setRecognitionLoadingVisible(false);
    };
    var handleFacutConfirm = function (image) {
        setZuploaderVisible(false);
        setCutState(false);
        setFacutVisible(false);
        setLoadingImage(image);
        requestCutFace(image);
    };
    var handleLoadingDone = function () {
        setPeopleIndex(peopleIndex + 1);
        setLoadingState('playing');
        if (directToPreview()) {
        }
        else {
            setRecognitionLoadingVisible(false);
        }
    };
    var handleTryAgainWhenError = function () {
        setLoadingState('playing');
        requestCutFace(loadingImage);
    };
    var handleCropWhenError = function () {
        setLoadingState('playing');
        setClipVisible(true);
        setRecognitionLoadingVisible(false);
    };
    var handleReplaceWhenError = function () {
        setLoadingState('playing');
        setZuploaderVisible(true);
        setRecognitionLoadingVisible(false);
    };
    var handleRecordIncementConfirm = function (addStatus) {
        relatedRecordProductStatus.current.addRecord = addStatus;
        if (shareLink) {
        }
        else {
            handleAddCart(factoryData.current);
        }
    };
    var handleAddRelativeProduct = function (relativeProducts) {
        _relativeProducts.current = relativeProducts;
        handlePassRelativeProduct();
    };
    var handlePassRelativeProduct = function () {
        if (relatedRecordProduct) {
            setRecordIncementVisible(true);
        }
        else
            handleAddCart(factoryData.current);
    };
    var handleClipConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, htmlImage, height, width, source;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, ((_a = _clip.current) === null || _a === void 0 ? void 0 : _a.toClipURL())];
                case 1:
                    result = _b.sent();
                    if (!result) return [3, 3];
                    return [4, loadHTMLImage(result)];
                case 2:
                    htmlImage = _b.sent();
                    height = htmlImage.height, width = htmlImage.width;
                    source = images[peopleIndex][currentSide - 1].source;
                    images[peopleIndex][currentSide - 1] = {
                        source: source,
                        image: result,
                        faceRecognizeData: undefined,
                        height: height,
                        width: width
                    };
                    setImages(cloneDeep(images));
                    if (editVisible) {
                        setEditVisible(false);
                    }
                    else if (taskStatus === TaskStatus.CropError ||
                        taskStatus === TaskStatus.NetworkError) {
                        setTaskStatus(TaskStatus.Choose);
                        setRecognitionLoadingVisible(false);
                    }
                    setClipVisible(false);
                    _b.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var handleEditConfirm = function () {
        setEditVisible(false);
    };
    var handleShowLoading = function (img) {
        if (img) {
            setRecognitionLoadingVisible(true);
            setLoadingState('playing');
            setLoadingImage(img);
        }
        else {
            setLoadingState('success');
        }
    };
    var handleDoubleSizeVisible = function (visible) {
        if (doubleSize)
            setIncrementDrawerVisible(visible);
        else
            handleIncrementDrawer();
    };
    var handleAddCart = function (factoryData, vipIncrement) { return __awaiter(void 0, void 0, void 0, function () {
        var token, encodeKey_1, relatedRecordProductIncrement, renderImages, stickerProduct, stickerSizeRaw, stickerSize, element, canvas, headImageData, imageUrls, headUrls, headFactoryImage, err_2, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setAddCartLoading(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 14, , 15]);
                    Gtag.event('event_add_cart');
                    return [4, getToken7n()];
                case 2:
                    token = _d.sent();
                    encodeKey_1 = "".concat(uploadKey('mini-me'));
                    return [4, Promise.all(canvasData.current.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var promiseList;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        promiseList = [];
                                        if (!item.image) return [3, 2];
                                        if (productType === 'balloon' && item.image.balloonCompose) {
                                            item.image.compose = item.image.balloonCompose;
                                            delete item.image.balloonCompose;
                                        }
                                        promiseList.push(upload2Oss({
                                            base64: item.image.compose,
                                            key: "".concat(encodeKey_1, "-compose-").concat(index, ".png")
                                        }).then(function (retsult) {
                                            console.log(retsult);
                                            item.image.compose = retsult;
                                        }));
                                        return [4, Promise.all(item.image.avatar.map(function (avatartItem, avatarIndex) { return __awaiter(void 0, void 0, void 0, function () {
                                                var originImage, image, origin;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            originImage = avatartItem.originImage, image = avatartItem.image;
                                                            return [4, compressImage(originImage, 800)];
                                                        case 1:
                                                            origin = _a.sent();
                                                            promiseList.push(upload2Oss({
                                                                base64: origin,
                                                                key: "".concat(encodeKey_1, "-origin-").concat(index, "-").concat(avatarIndex, ".png")
                                                            }).then(function (retsult) {
                                                                avatartItem.originImage = retsult;
                                                            }));
                                                            promiseList.push(upload2Oss({
                                                                base64: image,
                                                                key: "".concat(encodeKey_1, "-facut-").concat(index, "-").concat(avatarIndex, ".png")
                                                            }).then(function (retsult) {
                                                                avatartItem.image = retsult;
                                                            }));
                                                            return [2];
                                                    }
                                                });
                                            }); }))];
                                    case 1:
                                        _a.sent();
                                        return [3, 3];
                                    case 2:
                                        promiseList.push(upload2Oss({
                                            base64: item.lineText.compose,
                                            key: "".concat(encodeKey_1, "-compose-").concat(index, ".png")
                                        }).then(function (retsult) {
                                            item.lineText.compose = retsult;
                                        }));
                                        _a.label = 3;
                                    case 3: return [4, Promise.all(promiseList)];
                                    case 4:
                                        _a.sent();
                                        return [2];
                                }
                            });
                        }); }))];
                case 3:
                    _d.sent();
                    relatedRecordProductIncrement = undefined;
                    if (relatedRecordProductStatus.current.addRecord) {
                        relatedRecordProductIncrement =
                            handleTemplateArDataFilter((_a = canvasData.current[0].image) === null || _a === void 0 ? void 0 : _a.id) &&
                                templateIdDoSkipAr
                                ? handleTemplateArDataFilter((_b = canvasData.current[0].image) === null || _b === void 0 ? void 0 : _b.id).ar
                                : relatedRecordProduct;
                    }
                    renderImages = function (canvas, imageUrls, coordinates) { return __awaiter(void 0, void 0, void 0, function () {
                        var size;
                        return __generator(this, function (_a) {
                            for (size in coordinates) {
                                coordinates[size].map(function (coordinate) {
                                    var _a, _b;
                                    var imageUrlCloned = cloneDeep(imageUrls);
                                    var scale = Math.min(coordinate.width / ((_a = imageUrlCloned.width) !== null && _a !== void 0 ? _a : 0), coordinate.height / ((_b = imageUrlCloned.height) !== null && _b !== void 0 ? _b : 0));
                                    imageUrlCloned
                                        .set({
                                        left: coordinate.x,
                                        top: coordinate.y
                                    })
                                        .scale(scale);
                                    canvas.add(imageUrlCloned).renderAll();
                                });
                            }
                            return [2];
                        });
                    }); };
                    stickerProduct = selectedRelatedProduct.filter(function (item) {
                        return item.type == 'sticker';
                    });
                    if (!stickerProduct.length) return [3, 13];
                    stickerSizeRaw = (_c = stickerProduct[0].sku) === null || _c === void 0 ? void 0 : _c.split('-')[1];
                    stickerSize = stickerSizeRaw ? stickerSizeRaw : 'S';
                    if (!stickerSize) return [3, 13];
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 12, , 13]);
                    element = document.createElement('canvas');
                    canvas = new fabric.Canvas(element);
                    canvas.setDimensions({
                        width: stickerData.groundSize[stickerSize].width,
                        height: stickerData.groundSize[stickerSize].height
                    });
                    headImageData = images[0][0];
                    if (!(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id)) return [3, 7];
                    return [4, loadImageFromURL(stickerData.body["".concat(selectedOption.id, "-").concat(selectedColor[0].name[0].toUpperCase())])];
                case 5:
                    imageUrls = _d.sent();
                    return [4, renderImages(canvas, imageUrls, stickerData.coordinate[stickerSize].body)];
                case 6:
                    _d.sent();
                    _d.label = 7;
                case 7:
                    if (!(headImageData === null || headImageData === void 0 ? void 0 : headImageData.image)) return [3, 10];
                    return [4, loadImageFromURL(headImageData.image)];
                case 8:
                    headUrls = _d.sent();
                    return [4, renderImages(canvas, headUrls, stickerData.coordinate[stickerSize].head)];
                case 9:
                    _d.sent();
                    _d.label = 10;
                case 10:
                    headFactoryImage = canvas.toDataURL({
                        format: 'png',
                        quality: 1
                    });
                    return [4, upload2Oss({
                            base64: headFactoryImage,
                            key: "".concat(encodeKey_1, "-sticker.png")
                        }).then(function (result) {
                            var _a, _b, _c, _d;
                            stickerCompose.current = undefined;
                            stickerCompose.current = {
                                source: (_b = (_a = canvasData.current[0]) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.avatar[0].originImage,
                                element: (_d = (_c = canvasData.current[0]) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.avatar[0].image,
                                result: result
                            };
                        })];
                case 11:
                    _d.sent();
                    return [3, 13];
                case 12:
                    err_2 = _d.sent();
                    console.error('sticker generate error', err_2);
                    return [3, 13];
                case 13:
                    onConfirm({
                        makeHeight: factoryData.makeHeight,
                        makeWidth: factoryData.makeWidth,
                        layoutHeight: factoryData.layoutHeight,
                        layoutWidth: factoryData.layoutWidth,
                        color: factoryData.color,
                        body: factoryData.body,
                        isBodyFlip: factoryData.isBodyFlip,
                        sideCount: sideCount,
                        data: canvasData.current
                    }, selectedSize.name, incrementType.current, isShare, _relativeProducts.current, relatedRecordProductIncrement, colorVariantsValue.current, inputTextDataText, stickerCompose);
                    setAddCartLoading(false);
                    setStateInit();
                    onClose();
                    Gtag.event('event_add_cart_finish');
                    return [3, 15];
                case 14:
                    e_1 = _d.sent();
                    setAddCartLoading(false);
                    return [3, 15];
                case 15: return [2];
            }
        });
    }); };
    var handleCloseDoubleSizeChoose = function () {
        setPassPreviewEdit(false);
        setIncrementDrawerVisible(false);
    };
    useEffect(function () {
        if (peopleNumber > 1) {
            setTaskStatus(TaskStatus.Choose);
            setRecognitionLoadingVisible(false);
        }
        else {
            setZuploaderVisible(true);
        }
    }, [peopleNumber]);
    return (_jsxs(Provide, { value: {
            productType: productType,
            selectedSize: selectedSize,
            peopleNumber: peopleNumber,
            colors: colors,
            selectedColor: selectedColor,
            images: images,
            shop: shop,
            peopleIndex: peopleIndex,
            canvasData: canvasData,
            currentSide: currentSide,
            inputTextDataText: inputTextDataText,
            selectedRelatedProduct: selectedRelatedProduct,
            backSideNewImage: backSideNewImage,
            hasBackSideUpload: hasBackSideUpload,
            EditPageNextElement: EditPageNextElement,
            imageDataFor3dPreview: imageDataFor3dPreview,
            setCurrentSide: setCurrentSide,
            setBackSideNewImage: setBackSideNewImage,
            setInputTextDataText: setInputTextDataText,
            setCurrentSize: setCurrentSize,
            setPeopleIndex: setPeopleIndex,
            setSelectedColor: setSelectedColor,
            setEditVisible: setEditVisible,
            setSelectedRelatedProduct: setSelectedRelatedProduct,
            setHasBackSideUpload: setHasBackSideUpload,
            setViualizerPreviewVisible: setViualizerPreviewVisible,
            setImageDataFor3dPreview: setImageDataFor3dPreview
        }, children: [_jsx("div", { className: "mb:_sz-mb-0 _sz-relative _sz-mb-4 _sz-h-full _sz-w-full", children: Object.keys(sortOption).length > 0 && (_jsx(Choose, { ref: _choose, productType: productType, sortOption: sortOption, userImage: images.map(function (item) { return item[currentSide - 1]; }), selectedOption: selectedOption, setZuploaderVisible: setZuploaderVisible, setSelectedOption: setSelectedOption, setTaskStatus: setTaskStatus, setPassPreviewEdit: setPassPreviewEdit, onClose: function () { return handleClose(true); } })) }), taskStatus === TaskStatus.Preview && (_jsx("div", { className: " _sz-absolute _sz-inset-0 _sz-z-10", children: _jsx(Preview, { images: images, miniMeImage: selectedOption.origin, sideCount: sideCount, selectedColor: selectedColor, isPassEdit: passPrviewEdit, handleIncrementDrawer: handleIncrementDrawer, loadShareImage: loadShareImage, colorVariants: colorVariants, defaultTemplateId: defaultTemplateId, handleChangeIsFirst: function () {
                        _first.current = true;
                    }, setColorVariantsValue: function (values) {
                        return (colorVariantsValue.current = values);
                    }, setCurrentSide: setCurrentSide, setFactoryData: setFactoryData, setIncrementDrawerVisible: handleDoubleSizeVisible, setImageDrawerVisible: setImageDrawerVisible, setZuploaderVisible: setZuploaderVisible, setTaskStatus: setTaskStatus, setImages: setImages }) })), zuploaderVisible && (_jsx(Zuploader, { language: shop.language, onConfirm: handleZuploaderConfirm, onClose: handleZuploaderClose, handleSelectedLocalImage: handleSelectedLocalImage })), cutState && (_jsx(Cropper, { sources: [cutSource[peopleIndex]], onClose: handleCropperClose, onConfirm: function (ouput) { return handleCropperConfirm(ouput.images[0]); } })), facutVisible && (_jsx(Facut, { source: facutSource[peopleIndex], onClose: handleFacutClose, onConfirm: function (output) { return handleFacutConfirm(output.images[0]); } })), recognitionLoadingVisible && (_jsx(RecognitionLoading, { image: loadingImage, loadingState: loadingState, doneCallback: handleLoadingDone, tryAgainWhenError: handleTryAgainWhenError, cropWhenError: handleCropWhenError, replaceWhenError: handleReplaceWhenError })), editVisible && (_jsx(Edit, { images: images, setImages: setImages, setZuploaderVisible: setZuploaderVisible, onShowLoading: handleShowLoading, setClipVisible: setClipVisible, onClose: function () { return setEditVisible(false); }, onConfirm: handleEditConfirm })), clipVisible && (_jsx(Wrapper, { className: "_sz-z-[11]", children: _jsx(Clip, { ref: _clip, source: images[peopleIndex][currentSide - 1].source, theme: "light", onClose: function () { return setClipVisible(false); }, onClipConfirm: handleClipConfirm }) })), incrementDrawerVisible && selectedOption && (_jsx(DoubleSizeIncrementDrawer, { shop: shop, type: selectedOption.origin.type, image: ((_c = (_b = canvasData.current[currentSide - 1]) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.compose) || '', canvasDataFromRoot: canvasData, selectedOptionFromRoot: selectedOption, productIncrement: productIncrement, handleIncrement: handleIncrement, setIncrementType: setIncrementType, setAddedPrice: setAddedPrice, setZuploaderVisible: setZuploaderVisible, onClose: handleCloseDoubleSizeChoose })), relativeProductVisible && (_jsx(RelativeProduct, { stickerData: stickerData, selectedColor: selectedColor, selectedOption: selectedOption, shop: shop, relativeProducts: relativeProducts, onAdd: handleAddRelativeProduct, onPass: handlePassRelativeProduct, onClose: function () {
                    setRelativeProductVisible(false);
                    setSelectedRelatedProduct([]);
                } })), recordIncementVisible && relatedRecordProduct && (_jsx(RecordIncement, { shop: shop, isResize: true, sizeData: sizeData, relatedRecordProduct: relatedRecordProduct, onClose: function () { return setRecordIncementVisible(false); }, onConfirm: handleRecordIncementConfirm })), addCartLoading && (_jsx(Wrapper, { className: "_sz-z-[1000] _sz-flex\t_sz-items-center\t_sz-justify-center _sz-bg-white/[.95] _sz-p-8", children: _jsx(LoadingLine, {}) })), drawVisible && (_jsx(Drawer, { onClose: function () { return setDrawVisible(false); }, className: '_sz-static', children: textInputSettings && (_jsx(TextInputEdit, { language: shop.language, guideImage: guideImage, textInputSettings: textInputSettings, onClose: function () {
                        setDrawVisible(false);
                    }, onComfirm: function () {
                        setDrawVisible(false);
                        handleIncrementDrawer({ userText: true });
                    } })) })), imageDrawerVisible && selectedOption && (_jsx(DoubleSideEditDrawer, { option: selectedOption, avatars: canvasData.current, selectedColor: selectedColor, onClose: function () { return setImageDrawerVisible(false); }, onConfirm: function () {
                    handleIncrement();
                } })), viualizerPreviewVisible && (_jsx(VisualizePreview, { taskStatus: taskStatus, setViualizerPreviewVisible: setViualizerPreviewVisible, onSkipEdit: function () {
                    setTaskStatus(TaskStatus.Preview);
                    setPassPreviewEdit(true);
                    setViualizerPreviewVisible(false);
                }, onEnterEdit: function () {
                    setTaskStatus(TaskStatus.Preview);
                    setPassPreviewEdit(false);
                    setViualizerPreviewVisible(false);
                }, imageDataFor3dPreview: imageDataFor3dPreview }))] }));
};
export default Custom;
